import { render } from "./DetalharFormularioAvaliacao.vue?vue&type=template&id=5f44ff0a&scoped=true"
import script from "./DetalharFormularioAvaliacao.vue?vue&type=script&lang=js"
export * from "./DetalharFormularioAvaliacao.vue?vue&type=script&lang=js"

import "./DetalharFormularioAvaliacao.vue?vue&type=style&index=0&id=5f44ff0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f44ff0a"]])

export default __exports__